import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Modal } from 'antd';

import { classNames } from '@shared/utils/styles-utils';

import styles from '../styles.module.scss';

const cn = classNames(styles);

const NoteModal = ({
  isModalOpen,
  setIsModalOpen,
  handlerFunc,
  image,
  imageType,
  primaryNoteText,
  secondaryNoteText,
  primaryButtonText,
  secondaryButtonText,
}) => {
  const { t } = useTranslation('mentorCard');

  const renderFooter = [
    <>
      {secondaryButtonText && (
        <Button
          onClick={() => setIsModalOpen(false)}
          className={cn('material-card__AcquaintanceModal_btn')}
          key='setIsModalOpen'
        >
          {secondaryButtonText}
        </Button>
      )}
      {primaryButtonText && (
        <Button
          onClick={handlerFunc}
          type='primary'
          className={cn('material-card__AcquaintanceModal_btn')}
          key='handlerFunc'
        >
          {primaryButtonText}
        </Button>
      )}
    </>,
  ];

  return (
    <Modal
      open={isModalOpen}
      className={cn('material-card__AcquaintanceModal')}
      onCancel={() => setIsModalOpen(false)}
      footer={null}
      width={800}
    >
      <div className={cn('material-card__AcquaintanceModal-title')}>{t('title')}</div>
      <div className={cn('material-card__mentorAcquaintanceModalText')}>
        <span>{primaryNoteText}</span>
        {secondaryNoteText && <span>{secondaryNoteText}</span>}
      </div>
      <div className={cn('material-card__AcquaintanceModal-footer')}>
        {!!primaryButtonText && !!secondaryButtonText ? renderFooter : null}
      </div>
    </Modal>
  );
};

export default NoteModal;
